import config from './config';
import { local_storage_utils } from './frfr-webstorage-utils';
import ajax from './ajax-adapter';

const TOKEN_LOCAL_KEY = config.TOKEN_LOCAL_KEY;

const authUtils = {};


// TOKEN FOR SENDING WITH AJAX REQUESTS

authUtils.ajaxTokenValue = 'NONE';
authUtils.ajaxTokenSet = (token) => {
  if (typeof token === 'string') {
    authUtils.ajaxTokenValue = token;
  } else {
    authUtils.ajaxTokenValue = 'NONE';
  }
}
authUtils.ajaxTokenGet = () => {
  return authUtils.ajaxTokenValue;
}
authUtils.ajaxTokenDelete = () => {
  authUtils.ajaxTokenValue = 'NONE';
}


// TOKENS FOR STORING IN LOCAL STORAGE LONG TERM

authUtils.localTokenSet = async (token) => {
  let t = await local_storage_utils.item_set(TOKEN_LOCAL_KEY, token);
  return t;
};

authUtils.localTokenGet = async () => {
  let token = await local_storage_utils.item_get(TOKEN_LOCAL_KEY);
  return token;
};

authUtils.localTokenDelete = async () => {
  let t = await local_storage_utils.item_delete(TOKEN_LOCAL_KEY);
  return t;
};

//

authUtils.logoutProcedure = async () => {
  // frontend logout procedure
  if (config.useHeaderToken === true) {
    const token_header_key = config.TOKEN_HEADER_KEY;
    const _no_token_value = config.initial_token_value; // 'none_token_placeholder';
    ajax.ajaxHeadersConfigurator.setHeader(token_header_key, _no_token_value); // unset header
  }
  let t = await authUtils.ajaxTokenDelete();
  return true;
};


authUtils.autoLoginProcedure = async () => {
  console.log('autoLoginProcedure');
  let token = await authUtils.localTokenGet();
  if (config.useHeaderToken === true) {
    const token_header_key = config.TOKEN_HEADER_KEY;
    ajax.ajaxHeadersConfigurator.setHeader(token_header_key, token);
  }
  console.log(token);
  return token;
};

export default authUtils;